import styled from "styled-components";

export const LoginWrapperStyled = styled.div`
  display: flex;
  flex: 1;
  .sign-slogan {
    background-color: ${({ theme }) => theme.colors.soft.primary};
    border-radius: 10px;
    border: 1px solid ${({ theme }) => theme.colors.blue_ba};
    padding: 10px 14px;
    max-width: 420px;
    & .main-content {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 12px;
    }
  }
`;

export const ContainerStyled = styled.div`
  min-width: 500px;
  margin: auto;
  padding: 20px 40px 20px 40px;
  background-color: #fff;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
  border-radius: 10px;

  & .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }

  & .form-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;
  }
`;
